module.exports = {
	"TMDB_API_KEY": "5b61765551f62d502bf3b45a7e7310c0"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/config/config.prod.json
 ** module id = 239
 ** module chunks = 0
 **/